import styled from 'styled-components';
import { sizes } from '../../utils/style-utils';

export const WhatIsThisButton = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  font-size: 16px;
  @media only screen and (min-width : ${sizes.tablet}px) {
    margin-left: 10px;
  }
`;

export const SubHeaderWithInfoButton = styled.div`
  display: flex;
  white-space: nowrap;
  @media only screen and (max-width : ${sizes.mobile}px) {
    display: block;
  }
`;

export const DictionaryWrapper = styled.div`
  width: 100%;
  @media only screen and (min-width : ${sizes.tablet}px) {
    display: flex;
  }
`;

export const InfoIcon = styled.div`
  flex: 0 0 25px;
  align-self: center;
  @media only screen and (min-width : ${sizes.tablet}px) {
    flex: 0 0 30px;
  }
  @media only screen and (max-width : ${sizes.mobile}px) {
    margin-top: 5px;
  }
`;

export const MeasureButton = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-right: 5px;
  font-size: 16px;
`;
